<template>
  <div class="cart-page__vue">
    <div class="cart-page__content" v-if="count">
      <div class="cart-page__products">
        <TheCartPositions/>

        <a href="/cart/complete" class="cart-page__next-button button button__ellipse button_yellow texts texts_button">
          Оформить заказ
        </a>
      </div>

      <div class="cart-page__result">
        <TheCartResult page='1'/>
      </div>
    </div>

    <div class="cart-page__empty" v-else>
      <TheCartEmpty/>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
import TheCartPositions from "./TheCartPositions.vue";
import TheCartResult from "./TheCartResult.vue";
import TireTrack from "../icons/TireTrack.vue";
import TheCartOrderContacts from "./TheCartOrderContacts.vue";
import TheCartOrderReceiving from "./TheCartOrderReceiving.vue";
import TheCartOrderPay from "./TheCartOrderPay.vue";
import TheCartOrderComment from "./TheCartOrderComment.vue";
import CartIcon from "../icons/CartIcon.vue";
import EmptyCartIcon from "../icons/EmptyCartIcon.vue";
import TheCartEmpty from "./TheCartEmpty.vue";

export default {
  name: "TheCartPage",
  components: {
    TheCartEmpty,
    EmptyCartIcon,
    CartIcon,
    TheCartResult,
    TheCartPositions,
    TireTrack,
    TheCartOrderContacts,
    TheCartOrderReceiving,
    TheCartOrderPay,
    TheCartOrderComment,
  },
  computed: {
    ...mapState('cart', {
      'checkout': 'checkout',
      'politicUrl': 'politicUrl'
    }),
    ...mapState('order', {
      'name': 'name',
      'phone': 'phone',
      'clientType': 'clientType',
      'organization': 'organization',
      'errors': 'errors'
    }),
    ...mapGetters('cart', {
      'total': 'total',
      'count': 'count'
    })
  },
  methods: {
    ...mapActions({
      'loadCheckout': 'cart/loadCheckout',
      'loadPoliticUrl': 'cart/loadPoliticUrl',
      'send': 'order/send',
    }),
    async sendOrder() {
      if (!this.name
          || !this.phone
          || (this.clientType === 20 && !this.organization)
          || (this.receiving === 20 && !this.address)
      ) {
        const success = await this.send(false);
      } else {
        // this.$refs.submit.disabled = true;
        const success = await this.send(false);
      }
    }
  },

  mounted() {
    this.loadCheckout();
    this.loadPoliticUrl();
  }
}
</script>
